// South African provinces — used by the professional registration "Area" step.
export const SA_PROVINCES = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'North West',
  'Northern Cape',
  'Western Cape',
];

export const SERVICE_RADIUS_OPTIONS = [5, 10, 20, 30, 50, 75, 100];
